import { useEffect, useRef, useState } from "react";
import { Play, Pause, RotateCcw } from "lucide-react";

// Pré-visualização isolada de código ainda não validado: iframe sem scripts e com CSP sem recursos externos.
export function SvgSandbox({ svg }) {
  const doc = `<!doctype html><html><head><meta http-equiv="Content-Security-Policy" content="default-src 'none'; style-src 'unsafe-inline'; img-src data:">`
    + `<style>html,body{height:100%}svg{width:100%;height:100%;max-height:100vh;display:block}</style></head><body style="margin:0;background:#020617">${svg || ""}</body></html>`;
  return <iframe title="Pré-visualização isolada" sandbox="" srcDoc={doc} className="w-full aspect-video rounded-xl border border-slate-800 bg-slate-950" data-testid="studio-sandbox" />;
}

// Animação aprovada (SVG já validado no servidor) num Shadow DOM, com reproduzir/pausar/reiniciar.
export function StudioAnimation({ svg }) {
  const host = useRef(null);
  const [playing, setPlaying] = useState(true);
  const el = () => host.current?.shadowRoot?.querySelector("svg");
  useEffect(() => {
    const root = host.current.shadowRoot || host.current.attachShadow({ mode: "open" });
    root.innerHTML = `<style>:host{display:block} svg{width:100%;height:auto;display:block} :host(.paused) svg *{animation-play-state:paused!important}</style>${svg}`;
    setPlaying(true);
  }, [svg]);
  const toggle = () => {
    const s = el(); if (!s) return;
    if (playing) s.pauseAnimations?.(); else s.unpauseAnimations?.();
    host.current.classList.toggle("paused", playing);
    setPlaying(!playing);
  };
  const restart = () => {
    const s = el(); if (!s) return;
    s.setCurrentTime?.(0); s.unpauseAnimations?.();
    s.querySelectorAll("*").forEach((n) => { const a = n.style.animation; n.style.animation = "none"; void n.getBoundingClientRect(); n.style.animation = a; });
    host.current.classList.remove("paused"); setPlaying(true);
  };
  const btn = "inline-flex items-center gap-1.5 min-h-[44px] rounded-full border border-slate-700 px-3 text-xs text-slate-200 hover:border-sky-500/50 hover:text-sky-300 transition-colors";
  return (
    <div className="space-y-2" data-testid="studio-animation">
      <div ref={host} className="rounded-xl border border-slate-800 bg-[#020617] overflow-hidden" />
      <div className="flex gap-2">
        <button type="button" onClick={toggle} className={btn} data-testid="anim-toggle-btn">
          {playing ? <><Pause className="w-3.5 h-3.5" /> Pausar</> : <><Play className="w-3.5 h-3.5" /> Reproduzir</>}
        </button>
        <button type="button" onClick={restart} className={btn} data-testid="anim-restart-btn"><RotateCcw className="w-3.5 h-3.5" /> Reiniciar</button>
      </div>
    </div>
  );
}
